"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ControlContainer = _styledComponents["default"].div.attrs(function () {
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)('TOAST_CONTROL_CONTAINER'));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  margin-left: ", ";\n\n  & > * {\n    cursor: pointer;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.marginControl;
});

var _default = ControlContainer;
exports["default"] = _default;